import { env } from 'config/env';

const awsmobile = {
  aws_project_region: env.VITE_REGION,
  aws_cognito_region: env.VITE_REGION,
  aws_user_pools_id: env.VITE_USER_POOL_ID,
  aws_user_pools_web_client_id: env.VITE_USER_POOL_CLIENT_ID,
  oauth: {
    domain: env.VITE_OAUTH_DOMAIN,
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: env.VITE_REDIRECT_URL,
    redirectSignOut: env.VITE_REDIRECT_URL,
    responseType: 'code',
  },
};
export default awsmobile;
